import React from "react";
import { motion } from "framer-motion";
import { styles } from "../styles";
import { sectionWrapper } from "../hoc";
import { fadeIn, textVariant } from "../utils/motion";
import { testimonials } from "../constant";


const FeedbacCard = ({
  index,
  testimonial,
  name,
  designation,
  company,
  image,
}) => {
  return (
    <div
      
      className="flex flex-wrap gap-5 m-2 bg-black p-10 xs:w-[320px] w-full rounded-3xl"
    >
      <p className="text-white  font-black text-[48px]">"</p>

      <div className="gap-4 mt-1">
        <p className="text-[18px] text-white tracking-wider">{testimonial}</p>
        <div className="flex items-center justify-between gap-1 mt-7">
          <div className="flex flex-col flex-1">
            <p>
              <span className="blue-text-gradient">@</span> {name}
            </p>
            <p className="text-secondary">
              {designation} of {company}
            </p>
          </div>

          <img
          src={image}
          alt={name}
          width="10"
          height="10"
          className="object-cover w-10 h-10 rounded-full"/>
        </div>
      </div>
    </div>
  );
};

const Feedbacks = () => {
  return (
    <div className="mt-12 bg-black-100 rounded[20px]">
      <div
        className={`sm:px-16 px-6 sm:py-16 py-10 bg-tertiary rounded-2xl min-h-[300px]`}
      >
        <div >
          <p className={styles.sectionSubtext}>what others say</p>
          <h2 className={styles.sectionHeadText}>Testimonials.</h2>
        </div>
      </div>

      <div className={`${styles.paddingX} -mt-20 flex-col pb-14 2xl:flex 2xl:flex-row xl:flex xl:flex-row md:flex md:flex-row gap-7`}>
        {testimonials.map((testimonial, index) => (
          <FeedbacCard key={testimonial.name} index={index} {...testimonial} />
        ))}
      </div>
    </div>
  );
};

export default sectionWrapper(Feedbacks,"");
